/**
 * Sends a GET request to retrieve catalog data.
 * 
 * @returns {Promise<object|null>} - Returns a Promise that resolves to the catalog data if the request is successful, or null if there is an error or no data is received.
 */
import toast from "react-hot-toast";

export const getData = async () => {
    try {
        const response = await fetch('https://d10xp9krdkfyts.cloudfront.net/api/catalogData', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        const data = await response.json();

        if (data) {
            return data;
        } else {
            toast.error('No data received.');
            return null;
        }
    } catch (error) {
        toast.error('Unable to fetch data from server');
        console.error('Error:', error);
        return null;
    }
};
